import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCMSLinkComponent } from './custom-cms-link.component';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';



@NgModule({
  declarations: [CustomCMSLinkComponent],
  imports: [
    CommonModule,
    RouterModule,
    GenericLinkModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSLinkComponent: {
          component: CustomCMSLinkComponent
        }
      }
    } as CmsConfig)
  ]
})
export class CustomCMSLinkComponentModule { }
